import styled from "styled-components";

export const Container = styled.main`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--color-neutral-100);
  justify-content: end;

  * {
    font-family: var(--font-family-base);
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin: 0 10%;
  align-items: center;

  @media (max-width: 900px) {
    flex-direction: column;
    margin: 0;
    justify-content: space-around;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Logo = styled.img`
  width: 385.5px;
  height: 117.75px;
`;

export const FooterBar = styled.div`
  width: 100%;
  height: 56px;
  justify-content: center;
  display: flex;
  align-items: center;
  background-color: ${(props) => props.theme["@primary-color-brand"]};
`;

export const Label = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  margin: 0 10px;
  color: ${(props) => props.theme.text};
`;
